import React from 'react';
import { chartJsDefaultTooltip } from 'helpers/chartjs-utils';
import { Bar } from 'react-chartjs-2';
import { getColor, rgbaColor } from 'helpers/utils';

/**
 * @description REPORT > 정기심사 브리핑 - 차트
 */

const Chart = ({ chartData, title, isOptionChange }) => {
  const { labels, limitStdData, inspResultAvgData } = chartData || {};
  /**
   * labels: chart label
   * limitStdData: 한계기준값 data
   * inspResultAvgData: 검사결과 data
   */
  const chartDataMapping = {
    labels: labels,
    datasets: [
      {
        type: 'line',
        label: '한계기준값',
        borderColor: getColor('danger'),
        backgroundColor: getColor('danger'),
        borderWidth: 3,
        pointRadius: 0,
        fill: false,
        data: limitStdData
      },
      {
        type: 'bar',
        label: '검사결과값',
        backgroundColor: getColor('primary'),
        barPercentage: 0.5,
        borderWidth: 0,
        data: inspResultAvgData
      }
    ]
  };

  const noDataText = '데이터가 존재하지 않습니다.';
  const maxNumber = Math.max.apply(Math, limitStdData);
  let options = {
    interaction: {
      intersect: false,
      mode: 'nearest'
    },
    plugins: {
      title: {
        display: true,
        text: chartData === '' ? noDataText : title,
        font: {
          size: 16
        }
      },
      tooltip: chartJsDefaultTooltip(),
      legend: {
        position: 'bottom'
      }
    },
    scales: {
      x: {
        grid: {
          color: rgbaColor(getColor('black'), 0.1)
        }
      },
      y: {
        grid: {
          color: rgbaColor(getColor('black'), 0.1),
          drawBorder: true
        },
        suggestedMin: 0,
        suggestedMax: maxNumber + 1,
        beginAtZero: true
      }
    }
  };

  /**
   * 살모넬라: 검출, 불검출
   * chart option 변경
   */
  if (isOptionChange) {
    options = {
      interaction: {
        intersect: false,
        mode: 'nearest'
      },
      plugins: {
        title: {
          display: true,
          text: chartData === '' ? noDataText : title,
          font: {
            size: 16
          }
        },
        legend: {
          position: 'bottom'
        },
        tooltip: {
          backgroundColor: getColor('100'),
          borderColor: getColor('300'),
          borderWidth: 1,
          titleColor: getColor('black'),
          callbacks: {
            labelTextColor() {
              return getColor('black');
            },
            label: function (context) {
              const { chart, dataIndex, datasetIndex, dataset } = context || {};
              const data = chart.data;
              const label = dataset.label;

              /**
               * 살모넬라 data
               * 1: 불검출
               * 2: 검출
               */
              let value = '불검출';
              if (data.datasets[datasetIndex].data[dataIndex] === 2) {
                value = '검출';
              }

              return `${label} : ${value}`;
            }
          }
        }
      },
      scales: {
        y: {
          max: 2,
          ticks: {
            callback: val => {
              if (val === 2) {
                return '검출';
              } else if (val === 1) {
                return '불검출';
              }
              return '';
            }
          }
        }
      }
    };
  }

  /* view */
  return (
    <>
      <Bar data={chartDataMapping} options={options} height={150} />
    </>
  );
};

export default React.memo(Chart);
